import { Box } from '@chakra-ui/layout'

import { SidebarHeader } from './Header'
import { ParkingList } from './ParkingList'

export function Sidebar() {
  return (
    <Box
      width={{ base: '100%', notebook: '35%' }}
      marginRight={{
        notebook: '24px',
      }}
    >
      <Box height="100%">
        <SidebarHeader />
        <ParkingList />
      </Box>
    </Box>
  )
}
